import React, { Component } from 'react'

class FilterForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            userFilter: ""
        }

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = (e) => {
        this.setState({
            userFilter: e.target.value
        })
        this.props.onChange(e.target.value)
    }

    render() {
        return (
            <div>
                <label htmlFor="filter">Filter by name or nick: </label>
                <input type="text" id="filter"
                    value={this.state.userFilter}
                    onChange={this.handleChange} />
            </div>
        )
    }
}

export default FilterForm